// 7d52cba5-bda0-11ee-a566-3a399d50a7da = cms raleigh id
export const ASSESSMENT_FORM_IDS = ['7d52cba5-bda0-11ee-a566-3a399d50a7da', 'fd9bc669-a0b4-11ee-adb5-824b66c683b0'];

export const UNIQUE_ID_REGEX = /^[A-Za-z]{2}\d{6}$/;